import { useFetchInvoicesSummary } from '@features/invoices/hooks/useFetchInvoicesSummary'

import { useInvoicesListFilters } from './useInvoicesListFilters'

export const useInvoicesSummaryFiltered = () => {
  const [{ period, searchQuery }] = useInvoicesListFilters()

  return useFetchInvoicesSummary({ period, searchQuery })
}
